<template>
  <div>
    <v-container>
      <v-row justify="center">
        <h1>My Platforms</h1>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center" style="text-align:center">
        <p>Provide us platform account login for accessing TRADEinPOOL studies and indicators</p>
        <p>(necessary for API connectivity)</p>
      </v-row>
    </v-container>
    <h2>SIERRA CHART</h2>
    <div class="record-card mt-2" @click="editScAccount = true">
      <div class="tag">SC Account Name</div>
      <div class="tag-value float-left mt-2">{{accountname}}</div>
      <div class="float-right">
        <v-icon color="#b6c1cb">edit</v-icon>
      </div>
    </div>

    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-btn @click="download" x-large class="pa-4 pointer" color="blue">
          <v-icon>cloud_download</v-icon>
          
        
        
        <span class="ml-3">Download Studies</span>
        </v-btn>
      </v-row>
    </v-container>

    <v-dialog v-model="editScAccount" max-width="400px">
      <editScAccount @close="closeModal" />
    </v-dialog>
  </div>
</template>

<script>
import editScAccount from "./editScAccount";
export default {
  name: "PlatformAccount",
  components: {
    editScAccount
  },
  data() {
    return {
      editScAccount: false
    };
  },
  computed: {
    accountname() {
      return this.$store.getters.accountSierraChart;
    }
  },
  mounted() {},
  methods: {
    download(){
      window.open("https://www.tradeinpool.com/studies/tradeinpool.zip");
    },
    closeModal(val) {
      this[val] = false;
    }
  }
};
</script>

<style scoped>
.logodiv {
  min-width: 100px;
  height: 60px;
  background-color: white;
}
h2 {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif !important;
  font-size: 16px;
}
.record-card {
  width: 100%;
  float: left;
  background-color: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}

.record-card:hover {
  background: #232a35;
}
.tag {
  color: #b6c1cb;
  text-transform: uppercase;
}
.tag-value {
  font-size: 16px;
}
.avatar {
  border: 10px solid #333b47;
}
.platform {
  float: left;
  margin-left: 15px;
  margin-top: 25px;
}
</style>